import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateAgentData } from './actions/loginAuthenticationAction';
import AgentConsole from './components/AgentConsole';
import { appConfig } from './config/appConfig';
import { useGetCurrentUserQuery } from './reducers/userMeApi';
import { selectAuthenticationInfo } from './selectors/user';
import { LoginSuccess } from './types';

const WrapperConsole: React.FC = () => {
  const dispatch = useDispatch();
  const user: LoginSuccess = useSelector(selectAuthenticationInfo);

  const currentUser = useGetCurrentUserQuery();

  useEffect(() => {
    if (currentUser.isSuccess) {
      dispatch(updateAgentData(currentUser.data));
      appConfig.setCurrentUser(currentUser.data);
    }
  }, [currentUser, dispatch]);

  if (!user) {
    return null;
  }

  return <AgentConsole />;
};

export default WrapperConsole;
